import { useState, useEffect } from "react";
import styled from "@emotion/styled";

import { useFormikContext } from "formik";

import { useFormData } from "../contexts/FormData";

const useDraggable = ({
  useFormik = false,
  fieldName,
  field
}) => {
  const { values, setFieldValue } = useFormikContext() || {};

  const [ items, setItems ] = useState(useFormik ? (values[fieldName] || []) : (field || []));
  const [ draggedIndex, setDraggedIndex ] = useState(null);

  const removeItem = (index) => {
    let newSortedItems = [...items];
    newSortedItems.splice(index, 1);
    if (useFormik) {
      setFieldValue(fieldName, newSortedItems);
    } else {
      setItems(newSortedItems);
    }
  }

  const handleDragStart = (e, index) => {
    setDraggedIndex(index);
    e.dataTransfer.effectAllowed = 'move';
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  };

  const handleDrop = (e, dropIndex) => {
    e.preventDefault();
    
    if (draggedIndex === null || draggedIndex === dropIndex) {
      setDraggedIndex(null);
      return;
    }

    const newSortedItems = [...items];
    const [draggedItem] = newSortedItems.splice(draggedIndex, 1);
    newSortedItems.splice(dropIndex, 0, draggedItem);
    if (useFormik) {
      setFieldValue(fieldName, newSortedItems);
    } else {
      setItems(newSortedItems);
    }
    setDraggedIndex(null);
  };

  const handleDragEnd = () => {
    setDraggedIndex(null);
  };

  return { items, draggedIndex, handleDragStart, handleDragOver, handleDrop, handleDragEnd, removeItem };
}

export default useDraggable;